import {CreditInfo, CreditInfoDTO} from '../models/creditInfo.model';

export const mapCreditInfoDTOToModel = (dto: CreditInfoDTO): CreditInfo => {
  return {
    creditLimit: dto.creditLimit,
    totalSales: dto.totalSales,
    usedCredit: dto.usedCredit,
    remainingCredit: dto.remainingCredit,
    creditUsagePercentage: dto.creditUsagePercentage,
    paymentRating: dto.paymentRating,
    paymentRatingText: dto.paymentRatingText,
    paymentStatus: dto.paymentStatus,
    paymentStatusText: dto.paymentStatusText,
    overdueInvoices: dto.overdueInvoices,
    totalDue: dto.totalDue,
    lastPaymentDate: dto.lastPaymentDate
  };
};

export const mapCreditInfoModelToDTO = (model: CreditInfo): CreditInfoDTO => {
  return {
    creditLimit: model.creditLimit,
    totalSales: model.totalSales,
    usedCredit: model.usedCredit,
    remainingCredit: model.remainingCredit,
    creditUsagePercentage: model.creditUsagePercentage,
    paymentRating: model.paymentRating,
    paymentRatingText: model.paymentRatingText,
    paymentStatus: model.paymentStatus,
    paymentStatusText: model.paymentStatusText,
    overdueInvoices: model.overdueInvoices,
    totalDue: model.totalDue,
    lastPaymentDate: model.lastPaymentDate
  };
};
